import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import { baseUrl } from "../Univ";

function SellerDetails() {

  const user_id = localStorage.getItem("user_id");

  const [formData, setFormData] = useState({
    shop_name: "",
    shop_address: "",
    pincode: "",
    id_type: "PAN",
    id_number: "",
    id_holder_name: "",
    id_document: null,
    shipping_preference: "SELF",
    local_fee: 49,
    regional_fee: 56,
    national_fee: 77,
    account_holder: "",
    account_number: "",
    ifsc: "",
    default_gst_rate: 18
  });

  // -------------------------
  // HANDLE CHANGE
  // -------------------------
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  // -------------------------
  // LOAD SELLER PROFILE
  // -------------------------
  const loadProfile = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}seller/profile/?user_id=${user_id}`
      );

      setFormData(prev => ({
        ...prev,
        ...res.data
      }));

    } catch (err) {
      console.log("No Seller Profile Found");
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  // -------------------------
  // SAVE PROFILE
  // -------------------------
  const submitForm = async () => {

    try {
      const fd = new FormData();

      Object.keys(formData).forEach(key => {
        fd.append(key, formData[key]);
      });

      fd.append("user_id", user_id);

      await axios.post(
        `${baseUrl}seller/save/`,
        fd
      );

      Swal.fire("Success", "Seller Details Saved", "success");
             window.location.href = "/seller/";
    } catch (err) {
      Swal.fire("Error", "Failed to Save Seller Details", "error");
    }
  };
const getLocation = () => {

    if (!navigator.geolocation) {
      Swal.fire("Error", "GPS not supported", "error");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {

        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        try {
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
          );

          setFormData({
            ...formData,
            latitude: lat,
            longitude: lon,
            shop_address: res.data.display_name
          });

          Swal.fire("Success", "Address fetched successfully", "success");

        } catch {
          Swal.fire("Error", "Failed to fetch address", "error");
        }
      },
      () => Swal.fire("Error", "Location permission denied", "error")
    );
  };

  return (
    <section className="container mt-4">

      <h3 className="text-center bg-primary text-white p-2">
        Seller Details
      </h3>

      <table className="erp-table-modern">

        {/* SHOP DETAILS */}
        <tbody>

        <tr>
          <td>Shop Name</td>
          <td>
            <input
              name="shop_name"
              value={formData.shop_name}
              onChange={handleChange}
            />
          </td>
        </tr>

        <tr>
          <td>Shop Address</td>
          <td>
            <textarea
              name="shop_address"
              value={formData.shop_address}
              onChange={handleChange}
            />
            <button
                    type="button"
                    className="btn btn-info ms-2"
                    onClick={getLocation}
                  >
                    <i className="fa-solid fa-location-dot"></i>
                  </button>
          </td>
        </tr>
<tr>
                <td>Pincode</td>
                <td>
                  <input
                    type="number"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                  />
                </td>
              </tr>

        {/* PAN / GST */}

        <tr>
          <td>ID Type</td>
          <td>
            <label>
              <input
                type="radio"
                name="id_type"
                value="PAN"
                checked={formData.id_type === "PAN"}
                onChange={handleChange}
              /> PAN
            </label>

            &nbsp;&nbsp;

            <label>
              <input
                type="radio"
                name="id_type"
                value="GST"
                checked={formData.id_type === "GST"}
                onChange={handleChange}
              /> GST
            </label>
          </td>
        </tr>

        <tr>
          <td>{formData.id_type} Number</td>
          <td>
            <input
              name="id_number"
              value={formData.id_number}
              onChange={handleChange}
            />
          </td>
        </tr>

        <tr>
          <td>Name (as per {formData.id_type})</td>
          <td>
            <input
              name="id_holder_name"
              value={formData.id_holder_name}
              onChange={handleChange}
            />
          </td>
        </tr>

        <tr>
          <td>Upload Document</td>
          <td>
            <input
              type="file"
              name="id_document"
              onChange={handleChange}
            />
          </td>
        </tr>

        {/* SHIPPING */}

        <tr>
          <td>Shipping Preference</td>
          <td>
            <select
              name="shipping_preference"
              value={formData.shipping_preference}
              onChange={handleChange}
            >
              <option value="SELF">Pay by yourself</option>
              <option value="CUSTOMER">Customer Pays</option>
            </select>
          </td>
        </tr>
{formData.shipping_preference === "CUSTOMER" && (
  <>
    <tr>
      <td>Local Shipping Fee</td>
      <td>
        <input
          type="number"
          name="local_fee"
          value={formData.local_fee}
          onChange={handleChange}
        />
      </td>
    </tr>

    <tr>
      <td>Regional Shipping Fee</td>
      <td>
        <input
          type="number"
          name="regional_fee"
          value={formData.regional_fee}
          onChange={handleChange}
        />
      </td>
    </tr>

    <tr>
      <td>National Shipping Fee</td>
      <td>
        <input
          type="number"
          name="national_fee"
          value={formData.national_fee}
          onChange={handleChange}
        />
      </td>
    </tr>
  </>
)}
        {/* BANK DETAILS */}

        <tr>
          <td>Account Holder Name</td>
          <td>
            <input
              name="account_holder"
              value={formData.account_holder}
              onChange={handleChange}
            />
          </td>
        </tr>

        <tr>
          <td>Account Number</td>
          <td>
            <input
              name="account_number"
              value={formData.account_number}
              onChange={handleChange}
            />
          </td>
        </tr>

        <tr>
          <td>IFSC Code</td>
          <td>
            <input
              name="ifsc"
              value={formData.ifsc}
              onChange={handleChange}
            />
          </td>
        </tr>

        {/* TAX */}

        <tr>
          <td>Default GST %</td>
          <td>
            <input
              type="number"
              name="default_gst_rate"
              value={formData.default_gst_rate}
              onChange={handleChange}
            />
          </td>
        </tr>

        {/* SUBMIT */}

        <tr>
          <td colSpan="2" className="text-center">
            <button
              className="btn btn-success"
              onClick={submitForm}
            >
              Save Seller Details
            </button>
          </td>
        </tr>

        </tbody>

      </table>

    </section>
  );
}

export default SellerDetails;
